import { Suspense } from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom'
import AuthNavigateRegistrar from '@/components/auth/AuthNavigateRegistrar'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import appShellRoutes from '@/routes/appShellRoutes'
import authRoutes from '@/routes/authRoutes'
import PATHS from '@/routes/paths'

function RootLayout() {
  return (
    <>
      <AuthNavigateRegistrar />
      <Suspense fallback={<RouteSuspenseFallback />}>
        <Outlet />
      </Suspense>
    </>
  )
}

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route path={PATHS.ROOT} element={<Navigate to={PATHS.HOME} replace />} />
      {authRoutes()}
      {appShellRoutes()}
      <Route path="*" element={<Navigate to={PATHS.HOME} replace />} />
    </Route>,
  ),
)

export default function AppRouter() {
  return <RouterProvider router={router} />
}
